import {
  DATA_DRIVEN_SORT_ORDER,
  FIRST_PUBLISHED_DATE_DESC_SORT_ORDER,
  defaultNonFilterParams,
} from '@cinch-nx/data-search'

export const getDefaultSortingCriteria = (
  isDataDrivenSortOrderFlagEnabled?: boolean,
) =>
  isDataDrivenSortOrderFlagEnabled
    ? DATA_DRIVEN_SORT_ORDER
    : FIRST_PUBLISHED_DATE_DESC_SORT_ORDER

export const getDefaultNonFilterParams = (
  isDataDrivenSortOrderFlagEnabled?: boolean,
) => ({
  ...defaultNonFilterParams,
  sortingCriteria: getDefaultSortingCriteria(isDataDrivenSortOrderFlagEnabled),
})
